import { render, staticRenderFns } from "./cart-address.vue?vue&type=template&id=cd8d1476&scoped=true"
import script from "./cart-address.vue?vue&type=script&lang=js"
export * from "./cart-address.vue?vue&type=script&lang=js"
import style0 from "./cart-address.vue?vue&type=style&index=0&id=cd8d1476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8d1476",
  null
  
)

export default component.exports